import axios from "axios";
import { refreshAccessTokenInterceptor } from "../utils/refreshTokens";
import { fullAPIURL } from "../utils/requests";
import {
  requestAccessTokenInterceptor,
  responseStatusInterceptor,
} from "../utils/axios.utils";
import type { SendMessageType } from "../pages/People/types";

// MySQL message log
export type MessageLog = {
  id: number;
  uuid: string;
  clientId: number;
  userId: number;
  sentBy: number;
  email: string;
  messageType: string;
  messageSubject: string;
  messageBody: string;
  messageRaw: string;
  sendTimestamp: number;
  success: number;
  sendLog: string;
  remoteId: string;
  rejectReason: string;
  sent: number;
  bounced: number;
  opened: number;
  rejected: number;
  clicked: number;
};

export type MessageLogResponse = {
  success: boolean;
  messageLogs: MessageLog[];
};

const messagesAxios = axios.create({
  baseURL: `${fullAPIURL}/v2/communications/`,
  headers: { "Content-Type": "application/json" },
  validateStatus: null,
});

messagesAxios.interceptors.request.use(requestAccessTokenInterceptor);

messagesAxios.interceptors.request.use(refreshAccessTokenInterceptor);

messagesAxios.interceptors.response.use(responseStatusInterceptor);

export const sendSMS = async (message: string, to: string) => {
  return await messagesAxios.post("sms/send", { message, to });
};

export const sendMessage = async (data: SendMessageType) => {
  return await messagesAxios.post("queue-messages", data);
};

export const sendEmail = async (data: SendMessageType) => {
  return await messagesAxios.post("send-email", data);
};

export async function getClientUserMessageLogs(
  clientUuid: string,
  userUuid: string,
): Promise<MessageLogResponse> {
  const url = `/${clientUuid}/${userUuid}/messageLogs`;
  const response = await messagesAxios.get(url);
  return response.data;
}
